/**
 * Rounds a date up to the next quarter-hour boundary (00, 15, 30, 45).
 *
 * Seconds and milliseconds are zeroed. If rounding up the minutes crosses the
 * hour boundary (e.g. :50 → :60), the hour is incremented and minutes reset
 * to 0. The input date is not mutated.
 */
export function normalizeToNextQuarterHour(date: Date): Date {
  const normalized = new Date(date);
  const minutes = normalized.getMinutes();
  const roundedMinutes = Math.ceil(minutes / 15) * 15;

  normalized.setSeconds(0, 0);

  if (roundedMinutes === 60) {
    normalized.setHours(normalized.getHours() + 1);
    normalized.setMinutes(0);
    return normalized;
  }

  normalized.setMinutes(roundedMinutes);
  return normalized;
}

/**
 * Ensures the given date is not earlier than `minDate`. If it is, returns
 * `minDate` snapped to the next quarter-hour. Otherwise returns the date
 * unchanged.
 */
export function clampToMinDate(date: Date, minDate: Date): Date {
  if (date < minDate) {
    return normalizeToNextQuarterHour(minDate);
  }

  return date;
}
